export default {
  PRELOADER_DISPLAY(state) {
    const newState = state;

    newState.displayPreloader = true;
  },
  PRELOADER_HIDE(state) {
    const newState = state;

    newState.displayPreloader = false;
  },
};
